import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    title: 'test123',
    subtitle: '',
};

export const doneSlice = createSlice({
    name: "done",
    initialState,
    reducers: {
        updateTitle: (state, action) => {
            state.title = action.payload;
        },
        updateSubtitle: (state, action) => {
            state.subtitle = action.payload;
        }
    },
});

// export the actions
export const {updateTitle, updateSubtitle} = doneSlice.actions;

// export the reducer
export default doneSlice.reducer;